// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/hot-spot/style.less
// module id = 365
// module chunks = 0